// This is place for shared functionality between app and web

/* global jQuery, global */
import React from 'react';
import ReactDOM from 'react-dom';
// import {ScenarioListComponent} from './scenarios/ScenarioList.react';
import Relay from 'react-relay';
import {
    RelayNetworkLayer, retryMiddleware, urlMiddleware, authMiddleware,
    perfMiddleware, gqErrorsMiddleware
} from 'react-relay-network-layer';
import {IntlProvider, FormattedMessage} from 'react-intl';
import PublicQuery from './queries/PublicQuery';
import {getLocale} from './locales';
import myGraphQLLogger from './myGraphQLLogger';
import {getCommonMessages} from './getCommonMessages';
import ScenarioListPureReact from './scenarios/ScenarioListPure.react';
import ChannelDefDetailScenarios from './public-repo/ChannelDefDetailScenarios.react';
import {onInit as onInitApplicationSelect, initApplicationFilter, ApplicationObserver, getSelectedFromUrl} from './web/SelectWidget.react';
import config from '../common/config';
import './web/applicationBox.scss';
import './layout.scss';
import './web/scenarios.scss';
import './commonFunctions.scss';

function getLang() {
	if (window.location.host === "www.dativery.com") {
		let lang = document.body.parentElement.getAttribute('lang');

		return lang === 'cs-CZ' ? 'cs' : 'en';
	}

	return getLocale();
}

function scrollToBlinking(scrollToElement, i = 0) {
	setTimeout(() => {
		scrollToElement.css('outline-color', '#f1d204');

		setTimeout(() => {
			scrollToElement.css('outline-color', 'white');

			if (i < 2) {
				i += 1;
				scrollToBlinking(scrollToElement, i);
			}
		}, 300);
	}, 300);
}

export function scrollTo(id) {
	if (!jQuery) {
		throw new Error('The scrolling requires global jQuery.');
	}

	let scrollToElement = jQuery(id);

	if (scrollToElement.length) {
		jQuery('html, body').animate({
			scrollTop: scrollToElement[0].offsetTop - 120
		}, 600);

		scrollToBlinking(scrollToElement.children('span').first());
	}
}

function initRelay() {
	Relay.injectNetworkLayer(new RelayNetworkLayer([
		urlMiddleware({
			url: (req) => config.GLOBAL_API_URL + '/public/graphql?locale=' + getLang(),
		}),
		myGraphQLLogger(),
		gqErrorsMiddleware({
			disableServerMiddlewareTip: true
		}),
		perfMiddleware(),
		retryMiddleware({
			fetchTimeout: 30000,
			retryDelays: (attempt) => Math.pow(2, attempt + 4) * 100, // or simple array [3200, 6400, 12800, 25600, 51200, 102400, 204800, 409600],
			forceRetry: (cb, delay) => { window.forceRelayRetry = cb; },
			statusCodes: [500, 503, 504],
			allowMutations: true,
		}),
		authMiddleware({
			token: () => {}
		})

	], { disableBatchQuery: true }));
}


function renderDynamicScenarioSelector(targetEl, pagination) {
	const queryConfig = {
		queries: PublicQuery,
		name: 'User',
		params: {}
	};

	if (pagination) {
		queryConfig.params.relevantScenariosCnt = pagination;
	}

	ReactDOM.render(
		<IntlProvider locale={getLang()} messages={getCommonMessages(getLang())}>
			<div>
				<div id="relayLoading"><FormattedMessage defaultMessage="Loading…" id="common.loading" /></div>
				<Relay.Renderer
					Container={ScenarioListPureReact}
					environment={Relay.Store}
					onReadyStateChange={({aborted, done, error}) => {}}
					queryConfig={queryConfig}
				/>
			</div>
		</IntlProvider>, targetEl);
}

function renderDynamicApplicationSelector() {
	let elements = Array.prototype.slice.call(document.querySelectorAll('#destinationScenarios, #integratedScenarios, #helpingScenarios')).map(el => el.parentElement);

	let targetEl;
	elements.forEach((el, idx) => {
		if (idx === 0) {
			el.innerHTML = '';
			targetEl = el;
		}
		else {
			el.remove();
		}
	});

	const queryConfig = {
		queries: PublicQuery,
		name: 'User',
		params: {}
	};

	ReactDOM.render(
		<IntlProvider locale={getLang()} messages={getCommonMessages(getLang())}>
			<div>
				<div id="relayLoading"><FormattedMessage defaultMessage="Loading…" id="common.loading" /></div>
				<Relay.Renderer
					Container={ChannelDefDetailScenarios}
					environment={Relay.Store}
					onReadyStateChange={({aborted, done, error}) => {}}
					queryConfig={queryConfig}
				/>
			</div>
		</IntlProvider>, targetEl);
}

function onReady() {
	if (typeof (window) !== 'undefined') {

		// this element is generated only for web, it isn't in app
		let reactContentEl = document.getElementById('reactContent') || document.querySelector('.applications .channelDefDetail');
		let isApplication = !!document.querySelector('.applications .channelDefDetail');

		if (reactContentEl) {
			let targetEl = document.getElementById('scenarioListPure');
			onInitApplicationSelect();
			initApplicationFilter();

			if (getSelectedFromUrl().length) {
				initRelay();

				if (isApplication) {
					renderDynamicApplicationSelector();
				}
				else {
					renderDynamicScenarioSelector(targetEl);
				}
			}
			else {
				let listener = () => {
					if (isApplication) {
						renderDynamicApplicationSelector();
					}
					else {
						renderDynamicScenarioSelector(targetEl);
					}
					ApplicationObserver.unsubscribe(listener);
				};
				ApplicationObserver.subscribe(listener);

				if (!isApplication) {
					let placeholder = document.createElement('div');
					renderDynamicScenarioSelector(placeholder, 18);

					if (document.querySelector('.LoadingButton')) {
						document.querySelector('.LoadingButton').onclick = () => {
							targetEl.innerHTML = '';
							targetEl.append(placeholder);
						};
					}
				}

				setTimeout(() => {
					initRelay();
				});
			}
		}
	}
}

(function() {
	if (global && global.isNode) {
		return;
	}

	if (document.readyState === "complete" || (document.readyState !== "loading" && !document.documentElement.doScroll)) {
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout(onReady);
	} else {
		document.addEventListener("DOMContentLoaded", onReady);

		window.addEventListener("load", onReady);
	}
})();
